import InstructionNode, { InstructionNodeDragType } from 'app/src/game/InstructionNode';
import { XYCoord } from 'dnd-core';
import * as React from 'react';
import { useDragLayer } from 'react-dnd';

const styles = {
	wrapper: {
		position: 'fixed',
		pointerEvents: 'none',
		zIndex: 200,
		left: 0,
		top: 0,
		width: '100%',
		height: '100%',
	} as React.CSSProperties,
};

function getItemStyles(currentOffset: XYCoord | null): React.CSSProperties {
	if (!currentOffset) {
		return {
			display: 'none',
		};
	}

	const { x, y } = currentOffset;

	return {
		transform: `translate(${x}px, ${y}px)`,
	};
}

export default function InstructionNodeDragPreview(): React.ReactElement | null {
	const { item, itemType, currentOffset, isDragging } = useDragLayer((monitor) => ({
		item: monitor.getItem(),
		itemType: monitor.getItemType(),
		currentOffset: monitor.getSourceClientOffset(),
		isDragging: monitor.isDragging(),
	}));

	if (!isDragging || itemType !== InstructionNodeDragType) {
		return null;
	}

	const itemStyles = getItemStyles(currentOffset);

	return (
		<div style={styles.wrapper}>
			<div style={itemStyles}>
				<InstructionNode type={item.instructionType} />
			</div>
		</div>
	);
}
